import vCard from 'vcards-js';

let footer = {

    init: function () {
        const footerSelector = '#footer';
        footer.elements = document.querySelectorAll(footerSelector);
        footer.attemptActionIfNotEmpty(footer.ready);

        window.addEventListener('load', () => {
            footer.attemptActionIfNotEmpty(footer.loaded);
        });

        return footer;
    },

    attemptActionIfNotEmpty: function (action) {
        if (footer.elements && footer.elements.length > 0) {
            action();
        }
    },

    ready: () => {

        var saveBtn = document.getElementById("save-contact");
        saveBtn.addEventListener("click", function (e) {
            e.preventDefault();
            // Get the contact information from the website
            const contact = {
                name: "Berufsmaturitätsschule Winterthur",
                street: "Zürcherstrasse 28",
                zip: "8400",
                city: "Winterthur",
                phone: "+41 52 267 87 81",
                email: "info@bms-w.ch"
            };

            // create a vcard
            const vcard = vCard();
            vcard.firstName = contact.name;
            vcard.workPhone = contact.phone;
            vcard.email = contact.email;
            vcard.workAddress.street = contact.street;
            vcard.workAddress.postalCode = contact.zip;
            vcard.workAddress.city = contact.city;
            const vcardString = vcard.getFormattedString();

            const blob = new Blob([vcardString], {type: "text/vcard;charset=utf-8"});
            const url = URL.createObjectURL(blob);

            const newLink = document.createElement('a');
            newLink.download = contact.name + ".vcf";
            newLink.textContent = contact.name;
            newLink.href = url;

            newLink.click();
        });
    },

    loaded: () => {

    }

};

export default footer.init();